import {
  type Middleware,
  combineReducers,
  configureStore
} from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import appSlice from './app.slice';
import authSlice from './auth.slice';
import preApprovalSlice from './pre-approval.slice';
import uiSlice from './ui.slice';

const rootReducer = combineReducers({
  app: appSlice.reducer,
  auth: authSlice.reducer,
  preApproval: preApprovalSlice.reducer,
  ui: uiSlice.reducer
});

const middleware: Middleware[] = [];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware)
});

export const dispatch = store.dispatch.bind(store);
export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;

export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
